<template>
  <div class="leftContentBlock h-100" :style="{'background-image':'url('+leftBg+')'}">

    <h5 class="text-white text-center text-lg-left">{{t('leftContentBlock.header.firstPart')}} <br class="d-lg-none"> {{t('leftContentBlock.header.secondPart')}}</h5>

    <p class=" mt-lg-4 text-white text-center text-lg-left">{{t('leftContentBlock.paragraph.firstPart')}}<br class="d-lg-none"> {{t('leftContentBlock.paragraph.secondPart')}}</p>

<!--    <img v-bind:src="leftBg" alt=""/>-->
  </div>

</template>


<script>
import {ref} from 'vue'
import {useI18n} from 'vue-i18n'

import leftBg from '@/assets/imgs/left-bg.webp';


export default {
  name: "LeftContentBlock",
  setup() {
    const {t} = useI18n({useScope: 'global'})
    const select = ref(0)
    return {t, select}
  },
  data() {
    return {
      leftBg
    }
  },
}
</script>

<style scoped>


</style>